import {Component, Input, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Machine} from '@models/machine/machine';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {TranslateService} from '@ngx-translate/core';
import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {takeUntil} from 'rxjs/operators';
import {ElasticSearchResponseEntity} from '@models/elastic-search/response/elastic-search-response-entity';
import {ElasticSearchResult} from '@models/elastic-search/response/elastic-search-result';
import {Subject} from 'rxjs';
import {MachineryGroupDetailsService} from '@services/administration/machine-group/machinery-group-details.service';

@Component({
    selector: 'scitis-admin-machine-group-machines',
    templateUrl: './machine-group-machines.component.html',
    styleUrls: ['./machine-group-machines.component.scss'],
    standalone: false
})
export class MachineGroupMachinesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  machines: Machine[] = new Array<Machine>();

  @Input()
  machineGroupName: string = '';

  @Input()
  machineGroupId: number | null = null;
  @Input()
  whiteListedMachineryGroups: number[] | null = null;

  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  constructor(private tableHeaderSortableService: TableHeaderSortableService,
              public translate: TranslateService,
              private machineryGroupDetails: MachineryGroupDetailsService) {
  }

  ngOnInit(): void {
    this.setMachines();
  }

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.machines = this.tableHeaderSortableService.sortItems<Machine>(this.machines, column, direction);
  }

  ngOnDestroy(): void {

    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private setMachines() {
    this.machineryGroupDetails.listAssignedMachines(this.machineGroupId, this.whiteListedMachineryGroups)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (success: ElasticSearchResponseEntity) => {
        if (success?.result?.data && success.result.data.length > 0) {
          const result: ElasticSearchResult = success.result;
          this.machines = result.data;
        }
      }, error: (error) => {
        console.log(error);
      }
    });
  }

}
